import { render, staticRenderFns } from "./Talents.vue?vue&type=template&id=8b90aa08&scoped=true"
import script from "./Talents.vue?vue&type=script&lang=js"
export * from "./Talents.vue?vue&type=script&lang=js"
import style0 from "./Talents.vue?vue&type=style&index=0&id=8b90aa08&prod&lang=scss&scoped=true"
import style1 from "./Talents.vue?vue&type=style&index=1&id=8b90aa08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b90aa08",
  null
  
)

export default component.exports